import "./App.scss";
import { Route, Switch, useHistory } from "react-router-dom";
import WebFont from "webfontloader";
import Home from "./Home";
import AWS from 'aws-sdk';
import { useEffect, useState } from "react";
import { LoginCallback, SecureRoute, Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";

const OKTA_DOMAIN = process.env.REACT_APP_OKTA_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_OKTA_CLIENT_ID;
const CALLBACK_PATH = '/login/callback';

const ISSUER = `https://${OKTA_DOMAIN}/oauth2/default`
const HOST = window.location.host
const PROTOCOL = window.location.protocol
const REDIRECT_URI = `${PROTOCOL}//${HOST}${CALLBACK_PATH}`
const SCOPES = 'openid profile email'

const okta_config = {
    issuer: ISSUER,
    clientId: CLIENT_ID,
    redirectUri: REDIRECT_URI,
    scopes: SCOPES.split(/\s+/)
}

const oktaAuth = new OktaAuth(okta_config)

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_S3_BUCKET_REGION
});

const s3 = new AWS.S3();

WebFont.load({
  google: {
    families: ["Noto Sans:300,400,500,700"]
  }
});

const EXPIRATION = "X-GLOSSARY-TOKEN"
const VALID_FOR_H = 12

function App() {
  const [validating, setValidating] = useState(true);
  const [verified, setVerified] = useState(false);
  const history = useHistory();

  async function getObjectFromS3(key) {
    try {
      const params = {
        Bucket: process.env.REACT_APP_S3_BUCKET,
        Key: key
      };
      const data = await s3.getObject(params).promise();
      return data.Body.toString('utf-8');
    } catch (error) {
      console.error('Error retrieving object from S3:', error);
    }
  }

  function matchUrl(url: string, approvedUrls: string[]) {
    for (let i = 0; i < approvedUrls.length; i++) {
      const aUrl = approvedUrls[i]
      if (url === aUrl) return true
      if (aUrl.startsWith("https://*.")) {
        const regexPattern = `^https://[^/]+${aUrl.substring(9).split('.').map(part => part === '*' ? '[^/]*' : part.replace(/\./g, '\\.')).join('\\.')}$`;
        const regex = new RegExp(regexPattern);
        if (regex.test(url)) return true;
      }
    }
    return false;
  }

  const VerifyCORS = async () => {
    let verified = false;
    
    if (!document.referrer) return verified

    const data = await getObjectFromS3(process.env.REACT_APP_CORS)

    const org_urls = JSON.parse(data)['org_urls']
    const requesting_org = document.referrer.endsWith('/') ? document.referrer.slice(0, -1) : document.referrer;

    if (matchUrl(requesting_org, org_urls))
    {
      const expiration= new Date()
      expiration.setHours(expiration.getHours() + VALID_FOR_H)
      localStorage.setItem(EXPIRATION, expiration.toISOString())
      verified = true;
    }
    
    return verified
  }

  const VerifyToken = async () => {
    let verified = false;
    
    const urlParams = new URLSearchParams(window.location.search);
    if (!urlParams.has('atid')) return verified
    const token =urlParams.get('atid')
    urlParams.delete('atid')
    const newUrl = `${window.location.href.split('?')[0]}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
    window.history.replaceState({}, document.title, newUrl);

    const data = await getObjectFromS3(process.env.REACT_APP_LINKS)

    const tokens = JSON.parse(data)['access_tokens']
    const foundToken = tokens.find(t => t['token'] === token)
    const now = new Date()

    if (foundToken && new Date(foundToken['expires']) > now && !foundToken['revoked'])
    {
      const expiration= new Date()
      expiration.setHours(expiration.getHours() + VALID_FOR_H)
      localStorage.setItem(EXPIRATION, expiration.toISOString())
      verified = true;
    }
    
    return verified
  }

  const VerifyLocalSession = async () => {
    const expiration_time = new Date(localStorage.getItem(EXPIRATION))
    const now = new Date()
    return expiration_time > now
  }

  useEffect(() => {
    const filters = [VerifyCORS, VerifyToken, VerifyLocalSession]

    const run_filters = async () => {
      let filter_verified = false
      for (const filter of filters) {
        if (filter_verified) break;
        filter_verified = await filter()
      }
      setVerified(filter_verified)
      setValidating(false);
    }
    run_filters()

  }, [])

  const restoreOriginalUri = async (_oktaAuth: any, originalUri: any) => {
    history.replace(toRelativeUrl(originalUri || '/', window.location.origin))
  };

  const customAuthHandler = async () => {
    if (!validating && !verified) await oktaAuth.signInWithRedirect();
  }

  return (
    <div className="App">
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} onAuthRequired={customAuthHandler}>
          <Switch>
            {verified ? <Route exact path="/" component={Home}/> : <SecureRoute exact path="/" component={Home}/>}
            <Route path={CALLBACK_PATH} component={LoginCallback} />
          </Switch>
        </Security>
    </div>
  );
}

export default App;